var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.859716 10.1165C0.332031 11.2639 0.332031 12.5691 0.332031 15.1795V23.3322C0.332031 26.9575 0.332031 28.7702 1.45828 29.8964C2.5805 31.0186 4.38425 31.0226 7.98376 31.0227V21.4097C7.98376 19.7956 9.29226 18.4871 10.9064 18.4871H16.6742C18.2884 18.4871 19.5969 19.7956 19.5969 21.4097V31.0227C23.1964 31.0226 25.0002 31.0187 26.1225 29.8964C27.2487 28.7702 27.2487 26.9575 27.2487 23.3322V15.1795C27.2487 12.5691 27.2487 11.2639 26.721 10.1165C26.1933 8.96925 25.2023 8.11982 23.2203 6.42096L21.2977 4.773C17.7153 1.70233 15.924 0.166992 13.7904 0.166992C11.6567 0.166992 9.86547 1.70233 6.28302 4.773L4.3604 6.42096C2.3784 8.11982 1.3874 8.96925 0.859716 10.1165Z",
    fill: "#E1E1E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5969 31.0227V21.4097C17.5969 20.9001 17.1838 20.4871 16.6742 20.4871H10.9064C10.3968 20.4871 9.98376 20.9001 9.98376 21.4097V31.0227H17.5969Z",
    fill: "#E1E1E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.c49f2d020f03985ece35bc3c66120887.svg";
export { ForwardRef as ReactComponent };